
import { useQuery } from "@tanstack/react-query";
import { useClients } from "@/hooks/clients";
import { getRemainingSessionsCount, hasSoonExpiringSessions } from "@/utils/clientFilters";

export interface DashboardStats {
  totalClients: number;
  unpaidClients: number;
  lowSessionsClients: number;
  paidClients: number;
}

export const useDashboardStats = () => {
  const { data: clients = [], isLoading: isLoadingClients } = useClients();
  
  return useQuery({
    queryKey: ['dashboardStats', clients.length],
    queryFn: (): DashboardStats => {
      console.log('Calculating dashboard stats for', clients.length, 'clients');
      
      const totalClients = clients.filter(client => client.isActive).length;
      
      // Count clients with any payment issues (unpaid, partial, or pending)
      const unpaidClients = clients.filter(client => 
        client.isActive && 
        (client.paymentStatus === 'unpaid' || 
         client.paymentStatus === 'pending' || 
         client.paymentStatus === 'partial')
      ).length;
      
      const lowSessionsClients = clients.filter(client => 
        client.isActive && hasSoonExpiringSessions(client)
      ).length;
      
      // Only clients with 'paid' status are considered fully paid
      const paidClients = clients.filter(client => 
        client.isActive && client.paymentStatus === 'paid'
      ).length;

      const stats = {
        totalClients,
        unpaidClients,
        lowSessionsClients,
        paidClients
      };

      console.log('Dashboard stats calculated:', stats, {
        paymentStatusBreakdown: {
          unpaid: clients.filter(c => c.isActive && c.paymentStatus === 'unpaid').length,
          partial: clients.filter(c => c.isActive && c.paymentStatus === 'partial').length,
          pending: clients.filter(c => c.isActive && c.paymentStatus === 'pending').length,
          paid: clients.filter(c => c.isActive && c.paymentStatus === 'paid').length
        }
      });
      
      return stats;
    },
    enabled: !isLoadingClients,
  });
};
